<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <br />
        <h2>Profile</h2>
        <br />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <advertiser></advertiser>
        <br /><br />
      </div>
    </div>
  </div>
</template>

<script>
import AdvertiserForm from './advertiser'

export default {
  name: 'Profile',
  components: {
    advertiser: AdvertiserForm
  },
  data () {
    return {
      profile: {},
      action: 'Edit',
      token: localStorage.getItem('user-token')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/account/profile.vue